import trackEventManager from './trackEventManager';

export default trackEventManager;
